"use strict";


export function initInScope ($scope) {
    $scope.find('.js-show-more').each(function (key, value) {
       let $showMore = $(this),
           $showMoreContainer = $showMore.closest('.js-show-more-container'),
           $showMoreBtn = $showMoreContainer.find('.js-show-more__btn'),
           maxHeight = parseInt($showMore.data('max-height')) || $showMore.height();

        if(window.matchMedia('(max-width: 767px)').matches && $(this).data('max-height-mobile')) {
            maxHeight = $(this).data('max-height-mobile');
        }

       if($showMore.height() > maxHeight){
            $showMoreContainer.addClass('show-more');
            $showMore.css('max-height', maxHeight);
            $showMoreBtn.prop('hidden', false);
       }

        $showMoreBtn.on('click', function (e){
            if (!$showMoreContainer.hasClass('show-more')) {
                $showMore.css('max-height', maxHeight);
            } else {
                $showMore.css('max-height', 'none');
            }
            $showMoreContainer.toggleClass('show-more');
        });

    });
}
